import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import "./styles.scss";

/*Images*/

import { Link } from "@reach/router";

const HeroSection = (props) => {
  return (
    <div className="mlp-hero-container">
      <div className="page-logo">
        <Link
          to={`/marketing-launchpad/digital-marketing-course/${props.urlParams}`}
        >
          <StaticImage
            src="https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86yqku5m8yd0k8w.jpg"
            alt="The Marketing Launchpad"
            placeholder="none"
          />
        </Link>
      </div>

      <div className="hero-main-content">
        <div className="sub-title">
          <div className="one">#1</div>
          <h1 className="desc">
            {" "}
            Placement-linked <br /> Digital Marketing Course
          </h1>
        </div>
        <div className="item-list-container">
          <div className="list-item">
            94% placement rate & 2000+ students placed
          </div>
          <div className="list-item">
            Real accountability- If the job <br className="pc-none" />{" "}
            <b>{"< ₹4.5L"}</b>, we refund <b>60%</b>
          </div>
          <div className="list-item">
            Industry’s largest recruiting <br className="pc-none" /> partner
          </div>
        </div>
      </div>

      <div className="recruiter-container">
        <h4 className="recruiter-header-desk">
          Recruiters include top brands & agencies
        </h4>
        <h4 className="recruiter-header-mob">Students placed in:</h4>
        <div className="mlp-recruiters">
          <div className="before-hover">
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21nana2.png"
              className="company-img"
              alt="google"
            />
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21normu.webp"
              className="company-img"
              alt="nyka"
            />
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21ntx87.webp"
              className="company-img"
              alt="publicis"
            />
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21l5v9d.png"
              className="company-img"
              alt="bajajfin"
            />
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21opoar.webp"
              className="company-img"
              alt="tata cliq"
            />
          </div>
          <div className="on-hover">
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21nqqs7.webp"
              className="company-img"
              alt="performics"
            />
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21neeb4.webp"
              className="company-img"
              alt="groupm"
            />
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86yzpcm2aemygs.png"
              style={{ width: "50px" }}
              className="company-img mensa"
              alt="Mensa"
            />
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21n7bp2.webp"
              className="company-img"
              alt="coursera"
            />
            <img
              src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21ohypm.webp"
              className="company-img"
              alt="sokrati"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
